import { primaryColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const queriesAndComplaintsStyle = (theme) => ({
	queriesComplaints: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'row',
		[theme.breakpoints.down('xs')]: {
			flexWrap: 'wrap',
			display: 'block',
		},
	},
	iconContainer: {
		padding: 40,
		textAlign: 'center',
		[theme.breakpoints.down('xs')]: {
			padding: '16px 0 0 16px',
			margin: 0,
			textAlign: 'left',
		},
	},
	queriesComplaintsIconContainer: {
		margin: '12px 12px 12px 0',
		[theme.breakpoints.down('xs')]: {
			padding: 0,
			margin: '12px 0 0 0',
		},
	},
	queriesComplaintsColumn: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		margin: '12px 0 0 12px',
		[theme.breakpoints.down('xs')]: {
			margin: 0,
		},
	},
	card: {
		marginTop: '0px',
		marginBottom: '0px',
	},
	cardBody: {
		margin: 0,
		padding: '24px 24px 48px 24px',
		[theme.breakpoints.down('xs')]: {
			padding: '16px 16px 24px 16px',
		},
	},
	cardTicket: {
		margin: '24px 0 0 0',
	},
	queriesComplaintsTitle: {
		padding: '9px 0 0 4px',
	},
	mail: {
		color: primaryColor[0],
	},
	icon: {
		height: 56,
		width: 56,
		[theme.breakpoints.down('xs')]: {
			height: 48,
			width: 48,
		},
	},
	queriesComplaintsTextWrapper: {
		maxWidth: 536,
		padding: '16px 0 38px 0',
		[theme.breakpoints.down('xs')]: {
			padding: '16px 0 8px 0',
		},
	},
	queriesComplaintsButtons: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-evenly',
	},
	singleTabButtonWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		cursor: 'pointer',
		transition: 'all .1s ease-in-out',
		padding: 12,
		borderBottom: '2px solid transparent',
		height: 48,
		[theme.breakpoints.down('xs')]: {
			height: '48px',
			marginTop: '16px',
		},
		'&:hover': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.16)`,
			borderRadius: 4,
			'& p': {
				color: primaryColor[0]
			},
			'& svg': {
				color: primaryColor[0]
			},
		},
	},
	singleTabButtonActiveWrapper: {
		borderBottomColor: primaryColor[0],
	},
	singleTabButtonIconWrapper: {
		marginRight: 12,
		[theme.breakpoints.down('xs')]: {
			width: 24,
			height: 24,
		},
		'& svg': {
			fill: primaryColor[0],
			transition: 'all .1s ease-in-out',
		},
	},
});

export default queriesAndComplaintsStyle;
